// src/components/PrivacyPolicy.js
import React from 'react';

function PrivacyPolicy() {
    return (
        <div className="p-8">
        <h2 className="text-3xl font-bold mb-6">Políticas de Privacidad</h2>
        <div className="space-y-4 text-gray-700">
            <p>
                En Kifli, tu privacidad es nuestra prioridad. Esta Política de Privacidad describe cómo recopilamos, usamos y protegemos tu información personal cuando utilizas nuestros servicios.
            </p>
            <h3 className="text-xl font-bold pt-4">1. Información que Recopilamos</h3>
            <p>
                Recopilamos información que nos proporcionas directamente al registrarte, como tu nombre, apellido, correo electrónico, cédula y número de teléfono.
            </p>
            <h3 className="text-xl font-bold pt-4">2. Uso de la Información</h3>
            <p>
                Utilizamos tu información para gestionar tu cuenta, procesar tus pedidos, comunicarnos contigo y mejorar nuestros servicios. No compartiremos tu información personal con terceros sin tu consentimiento, excepto cuando sea requerido por la ley.
            </p>
            {/* ...Añade el resto de tus políticas aquí... */}
        </div>
        </div>
    );
}

export default PrivacyPolicy;